import React, { PureComponent } from "react";

class Timestamp extends PureComponent {
  render() {
    return (
      <div className="timeline-box">
        <div className="row">
          <div className="col-md-4">
            <p className="date">{this.props.date}</p>
          </div>
          <div className="col-md-8">
            <p className="content">{this.props.content}</p>
          </div>
        </div>
      </div>
    )
  }
}

const Timeline = () => (
  <section id="timeline">
    <div className="container">
      <div className="title-block">
        <h2>Timeline</h2>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Timestamp
            date="12 Nov 2018"
            content="Registration Opens"
          />
          <Timestamp
            date="15 Dec 2018"
            content="Training Workshop for Beginner Category"
          />
          <Timestamp
            date="16 Dec 2018"
            content="Training Workshop for Advanced Category"
          />
          <Timestamp
            date="26 Jan 2019"
            content="Training Workshop for Advanced Category"
          />
          <Timestamp
            date="2 Feb 2019"
            content="Training Workshop for Beginner Category"
          />
          <Timestamp
            date="9 Feb 2019"
            content="End of registration"
          />
          <Timestamp
            date="16 Feb 2019"
            content="Training Workshop by Supporting Training Partners"
          />
          <Timestamp
            date="23 Feb 2019"
            content="Opening Ceremony (Guest-of-Honour: Minister Ong Ye Kung)"
          />
          <Timestamp
            date="7 Mar 2019"
            content="Data Science Mentoring Clinic"
          />
          <Timestamp
            date="23 Mar 2019"
            content="Deadline for Project Submission"
          />
          <Timestamp
            date="30 Mar 2019"
            content="Award Ceremony & Prize Presentation"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Timeline;